import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-coupon-domain-modal',
  templateUrl: './coupon-domain-modal.component.html',
  styleUrls: ['./coupon-domain-modal.component.scss'],
})
export class CouponDomainModalComponent implements OnInit {
  couponDomain: string = 'test';

  constructor(
    public bsModalRef: BsModalRef,
    private router: Router
  ) {}

  ngOnInit(): void {}

  onCouponDomainChange(value) {
    this.couponDomain = value;
  }

  addCoupon() {
    this.router.navigate(['coupons/add-coupon', this.couponDomain]);
    this.bsModalRef.hide();
  }
}
